// extracted by mini-css-extract-plugin
export default {"signInModal":"VerifyEmail_signInModal__E6v+e","modalIcon":"VerifyEmail_modalIcon__gCVN0","bottomNote":"VerifyEmail_bottomNote__UgYdA"};